import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomNavbar from "../../../components/CustomNavbar";
// import SidebarCapacitacion from "../../../components/capacitacionDesarrollo/SidebarCapacitacion";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";

//redux
import {
  getMetricJobExperience,
  saveMetricJobExperience,
  editMetricJobExperience,
  deleteMetricJobExperience,
} from "../../../redux/capacitacionDesarrollo/MetricJobExperience/actions";
import SidebarNueveCajas from "../../../components/nueveCajas/SidebarNueveCajas";

const MetricJobExperience = (props) => {
  const fecha = new Date();
  var n = fecha.getFullYear();

  // Tipo de busqueda para filter
  const filters = [
    { id: "de", desc: "De" },
    { id: "hasta", desc: "Hasta" },
    { id: "porcentaje", desc: "Porcentaje" },
  ];

  const opcionMetrica = [
    { id: 1, desc: "Rango de años" },
    { id: 2, desc: "Mayor que" },
    { id: 3, desc: "Menor que" },
  ];

  // Variables de hooks
  const [show, setShow] = useState(true);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const [_anio, setAnio] = useState(n);
  const [inicialValorMinimo, setInicialValorMinimo] = useState(0);
  const [tipoBusqueda, setTipoBusqueda] = useState({ id: "de", desc: "De" });

  // Shema de Yup
  const schema = Yup.object().shape({
    opcion_metrica: Yup.string().required("**Campo requerido"),
    de: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(0, "El valor minimo es 0.")
      .max(100, "El valor maximo es 100.")
      // .required("**Campo requerido"),
      // .when("opcion_metrica", {
      //   is: "" || "1",
      //   then: Yup.string().required("**Campo requerido"),
      // }),
      .when("opcion_metrica", (opcion_metrica, schema) => {
        if (parseInt(opcion_metrica) !== 3)
          return schema.required("**Campo requerido");
        return schema;
      }),
    // .when("opcion_metrica", {
    //   is: (opcion_metrica) =>
    //     opcion_metrica === "" ||
    //     parseInt(opcion_metrica) === 1 ||
    //     parseInt(opcion_metrica) === 2,
    //   then: Yup.number().required("**Campo requerido"),
    // }),
    hasta: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(
        !edit ? inicialValorMinimo + 1 : editItem.de ? editItem.de + 1 : 0,
        `**El valor minimo es ${
          !edit ? inicialValorMinimo + 1 : editItem.de ? editItem.de + 1 : 0
        }.`
      )
      .max(100, "El valor maximo es 100.")
      // .required("**Campo requerido"),
      // .when("opcion_metrica", {
      //   is: "" || "1",
      //   then: Yup.string().required("**Campo requerido"),
      // }),
      .when("opcion_metrica", (opcion_metrica, schema) => {
        if (parseInt(opcion_metrica) !== 2)
          return schema.required("**Campo requerido");
        return schema;
      }),
    // .when("opcion_metrica", {
    //   is: (opcion_metrica) =>
    //     opcion_metrica === "" ||
    //     parseInt(opcion_metrica) === 1 ||
    //     parseInt(opcion_metrica) === 3,
    //   then: Yup.number().required("**Campo requerido"),
    // }),
    porcentaje: Yup.number()
      // .integer("El número no puede tener decimales.")
      .min(0, `El valor minimo es 0.`)
      .max(100, "El valor maximo es 100.")
      .required("**Campo requerido"),
    anio: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(2000, "El valor minimo es 0.")
      .required("**Campo requerido"),
  });

  const dispatch = useDispatch();

  // Variables de redux
  const {
    loaderMetricJobExperience,
    metricJobExperience,
    metricJobExperienceAll,
    metricJobExperienceAnio,
    metricJobExperienceFalla,
    saveLoaderMetricJobExperience,
    metricJobExperienceFormError,
  } = useSelector((store) => store.metricJobExperience);

  const pages = Math.ceil(
    (metricJobExperience ? metricJobExperience.count : 0) / limit
  );

  // Columnas para custom table
  const columns = [
    {
      Header: "Experiencia en puestos",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.de && value.row.original.hasta
            ? `${value.row.original.de}${" - "}${
                value.row.original.hasta
              }${" años"}`
            : !value.row.original.de && value.row.original.hasta
            ? `${"Menor a "}${value.row.original.hasta}${" años"}`
            : `${"Mayor a "}${value.row.original.de}${" años"}`}
        </div>
      ),
    },
    {
      Header: "Porcentaje",
      accessor: "porcentaje",
      Filter: "",
    },
    {
      Header: "Año",
      accessor: "anio",
      Filter: "",
    },
    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Metodos
  const _getMetricJobExperience = (
    offs = offset,
    lim = limit,
    filt = filter,
    ani = _anio
  ) =>
    dispatch(
      getMetricJobExperience({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "tipo_estado"
            ? "campaña".includes(filt.toLowerCase())
              ? 1
              : 2
            : filt,
        filter_2: ani,
      })
    );

  useEffect(() => {
    _getMetricJobExperience();
    // dispatch(getMetricJobExperienceAll());
  }, [_anio]);

  useEffect(() => {
    if (
      metricJobExperienceAll &&
      metricJobExperienceAll.data &&
      metricJobExperienceAll.data[metricJobExperienceAll.count - 1]
    ) {
      if (metricJobExperienceAll.data[metricJobExperienceAll.count - 1].hasta) {
        setInicialValorMinimo(
          metricJobExperienceAll.data[metricJobExperienceAll.count - 1].hasta +
            1
        );
      } else {
        setInicialValorMinimo(
          metricJobExperienceAll.data[metricJobExperienceAll.count - 1].de + 1
        );
      }
    } else {
      setInicialValorMinimo(0);
    }
  }, [metricJobExperienceAll]);

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onSubmit = (req) => {
    if (
      metricJobExperienceAll &&
      metricJobExperienceAll.data &&
      metricJobExperienceAll.data.length === 0 &&
      parseInt(req.opcion_metrica) !== 3
    ) {
      toastr.info("Debe agregar primero un valor 'menor que'");
      return;
    }
    if (
      metricJobExperienceAll &&
      metricJobExperienceAll.data &&
      metricJobExperienceAll.data.length > 0 &&
      metricJobExperienceAll.data.find(
        (m) => !m.de && m.hasta && parseInt(req.opcion_metrica) === 3
      ) &&
      metricJobExperienceAll.data.find(
        (m) => !m.de && m.hasta && parseInt(req.opcion_metrica) === 3
      ).id !== editItem.id
    ) {
      toastr.info("Ya se registro un valor 'menor que'");
      return;
    }
    if (
      metricJobExperienceAll &&
      metricJobExperienceAll.data &&
      metricJobExperienceAll.data.length > 0 &&
      metricJobExperienceAll.data.find(
        (m) => m.de && !m.hasta && parseInt(req.opcion_metrica) === 2
      ) &&
      metricJobExperienceAll.data.find(
        (m) => m.de && !m.hasta && parseInt(req.opcion_metrica) === 2
      ).id !== editItem.id
    ) {
      toastr.info("Ya se registro un valor 'mayor que'");
      return;
    }
    if (
      parseInt(req.de) >= parseInt(req.hasta) &&
      parseInt(req.opcion_metrica) !== 2 &&
      parseInt(req.opcion_metrica) !== 3
    ) {
      toastr.info("El valor mínimo no puede ser mayor o igual al valor máximo");
      return;
    }

    const _req = {
      // opcion_metrica: 3,
      // de: "",
      // hasta: 2,
      porcentaje: parseFloat(req.porcentaje).toFixed(2),
      anio: req.anio,
    };
    if (parseInt(req.opcion_metrica) !== 2) {
      _req.hasta = req.hasta;
    } else {
      _req.hasta = null;
    }
    if (parseInt(req.opcion_metrica) !== 3) {
      _req.de = req.de;
    } else {
      _req.de = null;
    }
    if (!edit) {
      dispatch(
        saveMetricJobExperience(_req, setShowFormModal, setInicialValorMinimo)
      );
    } else {
      _req.id = editItem.id;
      dispatch(editMetricJobExperience(_req, index, setShowFormModal, offset));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getMetricJobExperience(oOffset, limit, oSearch);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getMetricJobExperience(oOffset, limit, e.target.filter.value);
  };

  const onDelete = (item, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(
        deleteMetricJobExperience(item, index, offset, setInicialValorMinimo)
      );
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarNueveCajas show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              Métrica de experiencia en puesto
            </h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Col>
            <Row>
              <Form.Group as={Col} md={5} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Año
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loaderMetricJobExperience ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="aniio"
                          name="aniio"
                          className="col rounded-pill"
                          defaultValue={_anio}
                          disabled={
                            loaderMetricJobExperience ||
                            !metricJobExperienceAnio ||
                            (metricJobExperienceAnio &&
                              metricJobExperienceAnio.data.length === 0)
                          }
                          onChange={(e) => {
                            e.preventDefault();
                            if (e.currentTarget.value !== "") {
                              setAnio(parseInt(e.currentTarget.value));
                            } else {
                              setAnio(n);
                            }
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            // disabled
                          ></option>
                          {metricJobExperienceAnio &&
                            metricJobExperienceAnio.data
                              .sort((a, b) =>
                                a.anio > b.anio ? 1 : b.anio > a.anio ? -1 : 0
                              )
                              .map((item) => (
                                <option key={item.anio} value={item.anio}>
                                  {item.anio}
                                </option>
                              ))}
                        </Form.Control>
                      </Col>
                      {loaderMetricJobExperience ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Col>
          {!!metricJobExperienceFalla && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {metricJobExperienceFalla}
            </Alert>
          )}
          {loaderMetricJobExperience ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : metricJobExperience != null &&
            metricJobExperience.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable
                    columns={columns}
                    data={metricJobExperience.data}
                  />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={metricJobExperience.count}
                pages={pages}
                pagFunc={_getMetricJobExperience}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
      </div>
      {/*Modal editar*/}
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            opcion_metrica: edit
              ? editItem.hasta && editItem.de
                ? "1"
                : !editItem.hasta && editItem.de
                ? "2"
                : "3"
              : metricJobExperienceAll &&
                metricJobExperienceAll.data &&
                metricJobExperienceAll.data.length === 0
              ? "3"
              : "",
            de: edit ? (editItem.de ? editItem.de : "") : inicialValorMinimo,
            hasta: edit
              ? editItem.hasta
                ? editItem.hasta
                : ""
              : inicialValorMinimo + 1,
            porcentaje: edit ? parseFloat(editItem.porcentaje).toFixed(2) : "",
            anio: edit ? editItem.anio : n,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            handleBlur,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {edit ? "Editar Métrica" : "Crear Métrica"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {metricJobExperienceFormError &&
                typeof metricJobExperienceFormError !== "object" ? (
                  <Alert variant="danger" className="my-2">
                    {metricJobExperienceFormError}
                  </Alert>
                ) : null}
                {edit &&
                  values.opcion_metrica !== "" &&
                  parseInt(values.opcion_metrica) === 2 &&
                  index + offset < metricJobExperienceAll.data.length - 1 && (
                    <Alert variant="info" className="my-2">
                      No puede cambiar este registro con valor mayor que, porque
                      este no es el último registro
                    </Alert>
                  )}
                {edit &&
                  values.opcion_metrica !== "" &&
                  parseInt(values.opcion_metrica) === 2 &&
                  !(
                    index + offset <
                    metricJobExperienceAll.data.length - 1
                  ) && (
                    <Alert variant="info" className="my-2">
                      Una vez agregado un registro con valor mayor que, este se
                      considera el último registro
                    </Alert>
                  )}
                {!edit &&
                  values.opcion_metrica !== "" &&
                  _anio === n &&
                  parseInt(values.opcion_metrica) === 2 && (
                    <Alert variant="info" className="my-2">
                      Una vez agregado un registro con valor mayor que, este se
                      considera el último registro
                    </Alert>
                  )}
                {!edit &&
                  metricJobExperienceAll &&
                  metricJobExperienceAll.data &&
                  metricJobExperienceAll.data.length > 0 &&
                  metricJobExperienceAll.data.find((m) => m.de && !m.hasta) &&
                  _anio === n && (
                    <Alert variant="info" className="my-2">
                      Ya se agrego un registro con valor mayor que, este se
                      considera el último registro
                    </Alert>
                  )}
                {!edit && _anio !== n && (
                  <Alert variant="info" className="mt-1 mb-2">
                    El año seleccionado previamente, debe ser igual al año
                    seleccionado en el formulario o estar vacio.
                  </Alert>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Opciones de métricas
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm="12">
                        <Form.Control
                          as="select"
                          id="opcion_metrica"
                          name="opcion_metrica"
                          className="col rounded-pill"
                          isInvalid={
                            touched.opcion_metrica && errors.opcion_metrica
                          }
                          isValid={
                            touched.opcion_metrica && !errors.opcion_metrica
                          }
                          onBlur={handleBlur("opcion_metrica")}
                          value={values.opcion_metrica}
                          onChange={handleChange}
                          disabled={
                            (!edit &&
                              metricJobExperienceAll &&
                              metricJobExperienceAll.data &&
                              metricJobExperienceAll.data.length > 0 &&
                              metricJobExperienceAll.data.find(
                                (m) => m.de && !m.hasta
                              )) ||
                            (!edit && _anio !== n)
                          }
                        >
                          <option value="" disabled>
                            Opciones de métricas
                          </option>
                          {opcionMetrica.map((item) => (
                            <option
                              key={item.id}
                              value={item.id}
                              selected={
                                metricJobExperienceAll &&
                                metricJobExperienceAll.data &&
                                metricJobExperienceAll.data.length === 0 &&
                                item.id === 3
                              }
                              disabled={
                                (!edit &&
                                  metricJobExperienceAll &&
                                  metricJobExperienceAll.data &&
                                  metricJobExperienceAll.data.length === 0 &&
                                  item.id !== 3) ||
                                (!edit &&
                                  metricJobExperienceAll &&
                                  metricJobExperienceAll.data &&
                                  metricJobExperienceAll.data.length > 0 &&
                                  item.id === 3) ||
                                (edit && index === 0 && item.id !== 1)
                              }
                            >
                              {item.desc}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                    {touched.opcion_metrica && !!errors.opcion_metrica && (
                      <Col>
                        <small className="text-danger">
                          {errors.opcion_metrica}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    {values.opcion_metrica === "" ||
                    values.opcion_metrica === "1"
                      ? "Experiencia de puestos"
                      : "Años de experiencia"}
                  </Form.Label>
                  <Col>
                    <Row className="d-flex flex-wrap justify-content-between align-items-center">
                      {values.opcion_metrica === "3" ? null : (
                        <Col
                          md={
                            values.opcion_metrica === "" ||
                            values.opcion_metrica === "1"
                              ? 6
                              : 12
                          }
                        >
                          <Form.Control
                            id="de"
                            name="de"
                            isInvalid={
                              (touched.de && errors.de) ||
                              (touched.de &&
                                parseInt(values.de) >= parseInt(values.hasta) &&
                                parseInt(values.opcion_metrica) !== 2 &&
                                parseInt(values.opcion_metrica) !== 3)
                            }
                            isValid={
                              (touched.de && !errors.de) ||
                              (touched.de &&
                                !(
                                  parseInt(values.de) >= parseInt(values.hasta)
                                ) &&
                                parseInt(values.opcion_metrica) !== 2 &&
                                parseInt(values.opcion_metrica) !== 3)
                            }
                            onBlur={handleBlur("de")}
                            onChange={handleChange}
                            value={values.de}
                            className="rounded-pill"
                            type="number"
                            placeholder={
                              values.opcion_metrica === "" ||
                              values.opcion_metrica === "1"
                                ? "de"
                                : "Años de experiencia"
                            }
                            min={0}
                            max={100}
                            // disabled={values.opcion_metrica === ""}
                            disabled
                          ></Form.Control>
                          {touched.de && !!errors.de && (
                            <Col>
                              <small className="text-danger">{errors.de}</small>
                            </Col>
                          )}
                        </Col>
                      )}
                      {values.opcion_metrica === "2" ? null : (
                        <Col
                          md={
                            values.opcion_metrica === "" ||
                            values.opcion_metrica === "1"
                              ? 6
                              : 12
                          }
                        >
                          <Form.Control
                            id="hasta"
                            name="hasta"
                            isInvalid={
                              (touched.hasta && errors.hasta) ||
                              (touched.hasta &&
                                parseInt(values.de) >= parseInt(values.hasta) &&
                                parseInt(values.opcion_metrica) !== 2 &&
                                parseInt(values.opcion_metrica) !== 3)
                            }
                            isValid={
                              (touched.hasta && !errors.hasta) ||
                              (touched.hasta &&
                                !(
                                  parseInt(values.de) >= parseInt(values.hasta)
                                ) &&
                                parseInt(values.opcion_metrica) !== 2 &&
                                parseInt(values.opcion_metrica) !== 3)
                            }
                            onBlur={handleBlur("hasta")}
                            onChange={handleChange}
                            value={values.hasta}
                            className="rounded-pill"
                            type="number"
                            placeholder={
                              values.opcion_metrica === "" ||
                              values.opcion_metrica === "1"
                                ? "hasta"
                                : "Años de experiencia"
                            }
                            min={
                              !edit
                                ? inicialValorMinimo + 1
                                : parseInt(values.de) + 1
                            }
                            max={100}
                            disabled={
                              values.opcion_metrica === "" ||
                              (!edit &&
                                metricJobExperienceAll &&
                                metricJobExperienceAll.data &&
                                metricJobExperienceAll.data.length > 0 &&
                                metricJobExperienceAll.data.find(
                                  (m) => m.de && !m.hasta
                                )) ||
                              (!edit && _anio !== n)
                            }
                          ></Form.Control>
                          {touched.hasta && !!errors.hasta && (
                            <Col>
                              <small className="text-danger">
                                {errors.hasta}
                              </small>
                            </Col>
                          )}
                        </Col>
                      )}
                      {/* {(touched.de &&
                        parseInt(values.de) >= parseInt(values.hasta) &&
                        parseInt(values.opcion_metrica) !== 2 &&
                        parseInt(values.opcion_metrica) !== 3) ||
                      (touched.hasta &&
                        parseInt(values.de) >= parseInt(values.hasta) &&
                        parseInt(values.opcion_metrica) !== 2 &&
                        parseInt(values.opcion_metrica) !== 3) ? (
                        <Col>
                          <small className="text-danger">
                            **El valor mínimo no puede ser mayor o igual al
                            valor máximo
                          </small>
                        </Col>
                      ) : null} */}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Porcentaje
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="porcentaje"
                      name="porcentaje"
                      isInvalid={touched.porcentaje && errors.porcentaje}
                      isValid={touched.porcentaje && !errors.porcentaje}
                      onBlur={handleBlur("porcentaje")}
                      onChange={handleChange}
                      value={values.porcentaje}
                      className="rounded-pill"
                      type="number"
                      placeholder="0"
                      min={0}
                      max={100}
                      disabled={
                        (!edit &&
                          metricJobExperienceAll &&
                          metricJobExperienceAll.data &&
                          metricJobExperienceAll.data.length > 0 &&
                          metricJobExperienceAll.data.find(
                            (m) => m.de && !m.hasta
                          )) ||
                        (!edit && _anio !== n)
                      }
                    ></Form.Control>
                    {touched.porcentaje && !!errors.porcentaje && (
                      <Col>
                        <small className="text-danger">
                          {errors.porcentaje}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Año
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="anio"
                      name="anio"
                      isInvalid={touched.anio && errors.anio}
                      isValid={touched.anio && !errors.anio}
                      onBlur={handleBlur("anio")}
                      onChange={handleChange}
                      value={values.anio}
                      className="rounded-pill"
                      type="number"
                      placeholder="2000"
                      min={2000}
                      disabled
                    ></Form.Control>
                    {touched.anio && !!errors.anio && (
                      <Col>
                        <small className="text-danger">{errors.anio}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowFormModal(false)}
                >
                  Cerrar
                </Button>
                {(!edit &&
                  metricJobExperienceAll &&
                  metricJobExperienceAll.data &&
                  metricJobExperienceAll.data.length > 0 &&
                  metricJobExperienceAll.data.find((m) => m.de && !m.hasta)) ||
                (!edit && _anio !== n) ? null : (
                  <Button
                    className="rounded-pill"
                    disabled={
                      saveLoaderMetricJobExperience ||
                      (edit &&
                        values.opcion_metrica !== "" &&
                        parseInt(values.opcion_metrica) === 2 &&
                        index + offset < metricJobExperienceAll.data.length - 1)
                    }
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderMetricJobExperience && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      {/*Modal*/}
    </>
  );
};

export default MetricJobExperience;
